<template>
  <div>
    <div class="deal-grid text-sm text-text-ternary bg-line rounded py-4">
      <div>Дата</div>
      <div>Тикер</div>
      <div>Тип бумаги</div>
      <div>Событие</div>
      <div class="text-right">Кол-во</div>
      <div class="text-right">Цена <!--, {{ portfolioCurrency.symbol }}-->
      </div>
      <div class="text-right">Комиссия <!--, {{ portfolioCurrency.symbol }}-->
      </div>
      <div class="text-right">Сумма, {{ portfolioCurrency.symbol }}</div>
      <div></div>
    </div>
    <div class="divide-y divide-line pt-px">
      <DealsListItem v-for="(deal,i) in deals" :deal="deal" :key="i"/>
    </div>
  </div>
</template>

<script>
import DealsListItem from "@/components/cabinet/Investments/InvestmentDeals/DealListItem/DealsListItem";
import {mapGetters, mapState} from "vuex";

export default {
  name: "DealsList",
  components: {DealsListItem},
  props: {
    deals: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('investments/portfolios', ['portfolioCurrency']),
  }
}
</script>
<style lang="scss">
.deal-grid {
  @apply grid col-gap-8 -mx-6 px-6 ;
  grid-template-columns:11.4% 11.7% 12.2% 16.5% 5% 7.9% 10.5% 9.7% 1.2%;
}
</style>